export const alreadyHereQuest = {
    "id": "they_are_already_here",
    "titleKey": "chapter_they_are_already_here",
    "shortName": "ALRDY",
    "date": "10.05.2026",
    "status": "locked",
    "questMap": [
        {
            "id": "step_170",
            "label": {
                "en": "How to start the quest",
                "tr": "Görevi başlatma",
                "ru": "Получение квеста"
            },
            "type": "start",
            "details": {
                "location": { "en": "Shoreline / Woods / Marked Rooms", "tr": "Kıyı Şeridi / Ormanlık / İşaretli Odalar", "ru": "Берег / Лес / Меченые комнаты" },
                "objective": {
                    "en": "Acquire the quest line",
                    "tr": "Görev serisini başlat",
                    "ru": "Получите квест"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "Find the 'Eye of the World' note. It can be found in any Marked Room, on the island near the sunken barge (Shoreline), or by eliminating Cultists.",
                            "tr": "'Dünyanın Gözü' (Eye of the World) notunu bul. Herhangi bir İşaretli Oda'da, Kıyı Şeridi'ndeki batık mavnanın yakınındaki adada veya Kültistleri öldürerek bulabilirsin.",
                            "ru": "Найдите записку «Глаз мира». Её можно найти в любой меченой комнате, на острове возле затонувшей баржи (Берег) или убив сектантов."
                        }
                    }
                ]
            }
        },
        {
            "id": "step_175",
            "label": {
                "en": "Find the location linked to the Eye of the World",
                "tr": "Dünyanın Gözü ile bağlantılı konumu bul",
                "ru": "Найти место, связанное с Глазом Мира"
            },
            "type": "objective",
            "details": {
                "location": { "en": "Lighthouse", "tr": "Deniz feneri", "ru": "Маяк" },
                "objective": {
                    "en": "Investigate the location linked to the Eye of the World",
                    "tr": "Dünyanın Gözü ile bağlantılı konumu araştır",
                    "ru": "Исследуйте место, связанное с Глазом Мира"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "Search the flooded village on Lighthouse. Locate the torture room, pick up Audio Cassette #2 and the apartment key from the table.",
                            "tr": "Deniz Feneri'ndeki sular altındaki köyü araştır. İşkence odasını bul, 2 numaralı ses kasetini ve kurbanın daire anahtarını masadan al.",
                            "ru": "Обыщите затопленную деревню на Маяке. Найдите комнату пыток, заберите аудиокассету №2 и ключ от квартиры жертвы со стола."
                        }
                    }
                ]
            }
        },
        {
            "id": "step_206",
            "label": {
                "en": "Find the victim's apartment",
                "tr": "Kurbanın dairesini bul",
                "ru": "Найти квартиру жертвы"
            },
            "type": "objective",
            "details": {
                "location": { "en": "Streets of Tarkov", "tr": "Tarkov'un sokakları", "ru": "Улицы Таркова" },
                "objective": {
                    "en": "Locate the victim's apartment",
                    "tr": "Kurbanın dairesini bul",
                    "ru": "Найдите квартиру жертвы"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "Go to the courtyard near Klimov Shopping Center. On the 3rd floor, find the recording of Victim No. 1, a note, and the Cultist book.",
                            "tr": "Klimov Alışveriş Merkezi avlusundaki binaya git. 3. kattaki dairede kurban kaydını, notu ve Kültist kitabını bul.",
                            "ru": "Отправляйтесь во двор ТЦ «Климов». В квартире на 3-м этаже найдите запись жертвы №1, записку и книгу сектантов."
                        }
                    }
                ]
            }
        },
        {
            "id": "step_210",
            "label": {
                "en": "Eliminate the Cultist Priests",
                "tr": "Kültist Rahiplerini etkisiz hale getir",
                "ru": "Убить Жрецов Сектантов"
            },
            "type": "objective",
            "details": {
                "location": { "en": "Any Map", "tr": "Herhangi bir harita", "ru": "Любая карта" },
                "objective": {
                    "en": "Eliminate the Cultist Priests",
                    "tr": "Kültist Rahiplerini öldür",
                    "ru": "Убейте Жрецов Сектантов"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "Locate and eliminate 3 Cultist Priests on any map where they perform their night rituals.",
                            "tr": "Gece ritüeli yaptıkları herhangi bir haritada 3 Kültist Rahibini bul ve etkisiz hale getir.",
                            "ru": "Найдите и ликвидируйте 3 Жрецов Сектантов на любой карте, где они проводят ночные ритуалы."
                        }
                    }
                ]
            }
        },
        {
            "id": "step_226",
            "label": {
                "en": "Find more information about the Eye of the World",
                "tr": "Dünyanın Gözü hakkında daha fazla bilgi bul",
                "ru": "Найти больше информации о Глазе Мира"
            },
            "type": "objective",
            "details": {
                "location": { "en": "Marked Rooms", "tr": "İşaretli Odalar", "ru": "Меченые комнаты" },
                "objective": {
                    "en": "Collect more intel about the Eye of the World",
                    "tr": "Dünyanın Gözü hakkında ek bilgi topla",
                    "ru": "Соберите больше информации о Глазе Мира"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "Search any Marked Room to find a new note detailing cultist plans.",
                            "tr": "Kültist planlarını içeren yeni bir not bulmak için herhangi bir İşaretli Oda'yı kontrol et.",
                            "ru": "Обыщите любую меченую комнату, чтобы найти новую записку с планами сектантов."
                        }
                    }
                ]
            }
        },
        {
            "id": "step_227",
            "label": {
                "en": "Find the location marked by the Eye of the World",
                "tr": "Dünyanın Gözü ile işaretlenen noktayı bul",
                "ru": "Найти точку, отмеченную Глазом Мира"
            },
            "type": "objective",
            "details": {
                "location": { "en": "Lighthouse / Shoreline / Woods", "tr": "Deniz feneri / Kıyı Şeridi / Ormanlık", "ru": "Маяк / Берег / Лес" },
                "objective": {
                    "en": "Locate the coordinates marked by the Eye of the World",
                    "tr": "Dünyanın Gözü tarafından işaretlenen koordinatları bul",
                    "ru": "Найдите координаты, отмеченные Глазом Мира"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "Check the cell tower on Shoreline, the lower chalet on Lighthouse, and the village house in Woods for final clues.",
                            "tr": "Son ipuçları için Kıyı Şeridi'ndeki baz istasyonunu, Deniz Feneri'ndeki alt şaleyi ve Ormanlık'taki köy evini kontrol et.",
                            "ru": "Проверьте вышку связи на Берегу, нижнее шале на Маяке и дом в деревне в Лесу для поиска последних улик."
                        }
                    }
                ]
            }
        },
        {
            "id": "step_230",
            "label": {
                "en": "Access the secret facility of the NPO Cobalt",
                "tr": "Gizli NPO Cobalt tesisine sız",
                "ru": "Попасть на секретный объект НПО «Кобальт»"
            },
            "type": "objective",
            "details": {
                "location": { "en": "Interchange", "tr": "Değişim", "ru": "Развязка" },
                "objective": {
                    "en": "Infiltrate the NPO Cobalt facility",
                    "tr": "NPO Cobalt tesisine erişim sağla",
                    "ru": "Проникните на секретный объект НПО «Кобальт»"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "First, restore the Arshavin keycard via craft. Then, go to Interchange Power Station, turn on power, and enter the facility to download data.",
                            "tr": "Önce Arshavin kartını üretim (craft) ile onar. Ardından Değişim haritasındaki Güç İstasyonu'na git, elektriği aç ve verileri indirmek için tesise gir.",
                            "ru": "Сначала восстановите карту Аршавина через крафт. Затем идите на электростанцию Развязки, включите питание и войдите на объект для загрузки данных."
                        }
                    }
                ]
            }
        },
        {
            "id": "step_236",
            "label": {
                "en": "Talking to the Mechanic and the Quest Finale",
                "tr": "Mechanic ile görüş ve final",
                "ru": "Общение с Механиком и финал квеста"
            },
            "type": "objective",
            "details": {
                "location": { "en": "Menu / Traders", "tr": "Menü / Satıcılar", "ru": "Меню / Торговцы" },
                "objective": {
                    "en": "Conclude the quest line with Mechanic",
                    "tr": "Mechanic ile görüşerek görev serisini bitir",
                    "ru": "Завершите цепочку квестов, поговорив с Механиком"
                },
                "guideSteps": [
                    {
                        "text": {
                            "en": "Give the flash drive to Mechanic. Read the received documents for final achievements: 'AND THE LIGHT WENT OUT' and 'THROUGH ALIEN EYES'.",
                            "tr": "Flash belleği Mechanic'e teslim et. Final başarımlarını almak için gelen belgeleri oku: 'AND THE LIGHT WENT OUT' ve 'THROUGH ALIEN EYES'.",
                            "ru": "Передайте флешку Механику. Прочтите полученные документы для финальных достижений: «И СВЕТ УГАС» и «ЧУЖИМИ ГЛАЗАМИ»."
                        }
                    }
                ]
            }
        }
    ]
}